module.exports = __webpack_public_path__ + "img/wide.f704da6a.jpg";